import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "./components/ThemeProvider";
import { AuthProvider } from "./context/AuthContext";

// Pages
import Landing from "./pages/Landing";
import VoiceChat from "./pages/VoiceChat";
import Dashboard from "./pages/Dashboard";
import KnowledgeBase from "./pages/KnowledgeBase";
import Settings from "./pages/Settings";
import CallHistory from "./pages/CallHistory";
import AgentSettings from "./pages/AgentSettings";
import CalendarSettings from "./pages/CalendarSettings";
import TwilioSettings from "./pages/TwilioSettings";
import ShopCalendar from "./pages/ShopCalendar";
import Businesses from "./pages/Businesses";
import Pricing from "./pages/Pricing";
import Signup from "./pages/Signup";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import BusinessDashboard from "./pages/BusinessDashboard";
import Login from "./pages/Login";
import TryDemo from "./pages/TryDemo";
import Admin from "./pages/Admin";
import SalesRepDashboard from "./pages/SalesRepDashboard";
import JoinInvite from "./pages/JoinInvite";
import SmsOptIn from "./pages/SmsOptIn";
import LegalPage from "./pages/LegalPage";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";

// Components
import Layout from "./components/Layout";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/join/:token" element={<JoinInvite />} />
              <Route path="/sms-optin/:businessId" element={<SmsOptIn />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<Landing />} />
                <Route path="voice" element={<VoiceChat />} />
                <Route path="call" element={<VoiceChat />} />
                <Route path="try-demo" element={<TryDemo />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="calls" element={<CallHistory />} />
                <Route path="agent-settings" element={<AgentSettings />} />
                <Route path="calendar" element={<ShopCalendar />} />
                <Route path="calendar-settings" element={<CalendarSettings />} />
                <Route path="twilio" element={<TwilioSettings />} />
                <Route path="businesses" element={<Businesses />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="signup" element={<Signup />} />
                <Route path="login" element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="verify-email" element={<VerifyEmail />} />
                <Route path="subscription/success" element={<SubscriptionSuccess />} />
                <Route path="subscription/cancel" element={<Pricing />} />
                <Route path="minutes/success" element={<SubscriptionSuccess />} />
                <Route path="sms-addon/success" element={<SubscriptionSuccess />} />
                <Route path="business/:businessId" element={<BusinessDashboard />} />
                <Route path="admin/knowledge" element={<KnowledgeBase />} />
                <Route path="admin/settings" element={<Settings />} />
                <Route path="admin" element={<Admin />} />
                <Route path="sales" element={<SalesRepDashboard />} />
                <Route path="terms" element={<Terms />} />
                <Route path="privacy" element={<Privacy />} />
                <Route path="contact" element={<Contact />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                color: 'hsl(var(--foreground))',
              },
            }}
          />
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
